import styled, { css } from 'styled-components';
import { CDN_URL } from "../../../../constants/urls";
export var SocialIconsList = styled.ul.withConfig({
  componentId: "sc-10y3gl5-0"
})(["display:flex;flex-wrap:wrap;list-style:none;padding:0;margin:0;"]);
export var SocialIconsListItem = styled.li.withConfig({
  componentId: "sc-10y3gl5-1"
})(["display:inline-block;width:25px;height:30px;background-image:url(", "/shared-modules/images/sprites-social-", ".svg);background-repeat:no-repeat;opacity:0.8;margin-left:8px;text-indent:-9999px;transition:opacity 0.2s ease;", " &:hover{opacity:1;}@media only screen and (max-width:640px){margin:0 0 0 1px;transform:scale(0.93);}&:first-child{margin:0;}a{width:100%;height:100%;display:block;}"], CDN_URL, function (props) {
  return props.palette;
}, function (props) {
  return css(["background-position:", "px center;"], props.backgroundPosition || 0);
});